/**
 * aboutus.js
 * copyright © 2022 PrimeTimeConstruction
 */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { aboutUsData } from "../aboutUsTemplateData";
import parse from "html-react-parser";

import "../assets/css/aboutus.css";

function AboutUs() {
  const { pathname } = useLocation();
  let urlTosearch = pathname.split("/");
  urlTosearch = urlTosearch[1];
  const [pageData, setPageData] = useState([]);

  //for opening page from top whenever user lands on this page
  useEffect(() => {
    window.scrollTo(0, 0);
    if (urlTosearch) {
      const result = aboutUsData.filter(
        (val) => val.url.toLowerCase() === urlTosearch.toLowerCase()
      );
      if (result && result.length > 0) {
        setPageData(result);
      } else {
        setPageData([]);
      }
    }
  }, [urlTosearch]);

  return (
    <section className="content-wrapper about-us">
      {pageData && pageData.length > 0 ? (
        <div className="ania-content pt-lg-1 pt-0">
          <div className="container-fluid px-0">
            <div className="main-content">
              <div className="col-lg-12 px-lg-5 px-4">
                <h1 className="page-title page-title-lg mb-0">
                  {pageData[0].pageTitle}
                </h1>
              </div>
            </div>
          </div>
          <div className="container-fluid px-0">
            <div className="container-width">
              <div className="about-us-content" style={{ paddingTop: "0" }}>
                <h2 className="text-center">{pageData[0].title}</h2>
                <p>{pageData[0].p1}</p>
                {pageData[0].stats && pageData[0].stats.length > 0 ? (
                  <div className="stats">
                    {pageData[0].stats.map((val, i) => (
                      <div key={i}>
                        <strong>{val.value}</strong>
                        <small>{val.title}</small>
                      </div>
                    ))}
                  </div>
                ) : null}
                <p>{parse(pageData[0].p2)}</p>
                <p>{pageData[0].p3}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h1
          style={{ textAlign: "center", margin: "120px 50px", color: "grey" }}
        >
          {" "}
          No Data Found For This Url
        </h1>
      )}
    </section>
  );
}

export default AboutUs;
